import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=0abb20de&"
import script from "./ArrowLink.vue?vue&type=script&lang=js&"
export * from "./ArrowLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowLeftLight: require('/vercel/path0/components/icons/ArrowLeftLight.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
